import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "select-label batch-select" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "select-label blade-select" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "form-check form-check-inline" }
const _hoisted_9 = { class: "form-check form-check-inline" }
const _hoisted_10 = { class: "form-check form-check-inline" }
const _hoisted_11 = { class: "form-check" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.selectedBatches)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          disabled: _ctx.isLoading,
          class: "animation-controls controls"
        }, [
          _createElementVNode("label", _hoisted_2, [
            _cache[7] || (_cache[7] = _createTextVNode("Batch: ", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "range",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedBatch) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedBatches, (batch) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: batch,
                  value: batch
                }, _toDisplayString(batch), 9, _hoisted_3))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedBatch]
            ])
          ]),
          _createElementVNode("label", _hoisted_4, [
            _cache[8] || (_cache[8] = _createTextVNode("Blade: ", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "range",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedBlade) = $event)),
              disabled: _ctx.selectedBatch === null
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bladesList, (blade) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: blade,
                  value: blade
                }, _toDisplayString(blade), 9, _hoisted_6))
              }), 128))
            ], 8, _hoisted_5), [
              [_vModelSelect, _ctx.selectedBlade]
            ])
          ]),
          _createElementVNode("label", _hoisted_7, [
            _cache[12] || (_cache[12] = _createTextVNode("Axes: ", -1)),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                name: "axisCheckbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedAxis) = $event)),
                id: "xRadio",
                value: "x"
              }, null, 512), [
                [_vModelRadio, _ctx.selectedAxis]
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("label", {
                class: "form-check-label",
                for: "xRadio"
              }, "x", -1))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                name: "axisCheckbox",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedAxis) = $event)),
                id: "yRadio",
                value: "y"
              }, null, 512), [
                [_vModelRadio, _ctx.selectedAxis]
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("label", {
                class: "form-check-label",
                for: "yRadio"
              }, "y", -1))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                name: "axisCheckbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedAxis) = $event)),
                id: "zRadio",
                value: "z"
              }, null, 512), [
                [_vModelRadio, _ctx.selectedAxis]
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("label", {
                class: "form-check-label",
                for: "zRadio"
              }, "z", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.lineHistory) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.lineHistory]
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("label", {
              class: "form-check-label",
              for: "flexCheckDefault"
            }, " Line History ", -1))
          ]),
          _createElementVNode("button", {
            class: "btn btn-success btn-sm refresh-button button-content",
            title: "Refresh Animation",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.makeSVGPlot && _ctx.makeSVGPlot(...args))),
            disabled: _ctx.selectedBlade === null
          }, [
            _cache[14] || (_cache[14] = _createElementVNode("div", null, "Refresh", -1)),
            _cache[15] || (_cache[15] = _createElementVNode("div", null, "Animation", -1)),
            _createVNode(_component_vue_feather, {
              type: "bar-chart",
              size: "16px"
            })
          ], 8, _hoisted_12)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _cache[16] || (_cache[16] = _createElementVNode("div", {
      class: "d3-animation",
      id: "d3-animation"
    }, null, -1))
  ], 64))
}